import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=fcd75e1c&scoped=true"
import script from "./InfoView.vue?vue&type=script&lang=ts"
export * from "./InfoView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd75e1c",
  null
  
)

export default component.exports